import { render } from "./DisparadorNotificaciones.vue?vue&type=template&id=8e819682"
import script from "./DisparadorNotificaciones.vue?vue&type=script&lang=js"
export * from "./DisparadorNotificaciones.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__